export default (inputDate) => {
  if (typeof inputDate === 'undefined') return '-';
  if (inputDate === null) return '-';
  if (!inputDate) return '-';
  if (inputDate && inputDate.replace(/\s+/g, '').length < 1) return '-';
  return inputDate;
};
